// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3-IEK","inner":"Footer_inner__dQnKh"};